import { hasTrialOrgStarted } from '@src/domain/Organization/OrganizationHelpers';
import { OrganizationComplete } from '@src/domain/Organization/OrganizationInterfaces';
import * as React from 'react';

import { IRootState, ThunkDispatch } from '@src/domain';
import { connect } from 'react-redux';
import { getTrialActive, getTrialStatus, getHasPaidPro } from '@src/domain/User/UserSelectors';
import { localizeDate } from '@src/utils/timeUtils';
import { getOrganizationList } from '@src/domain/Organization/OrganizationSelectors';
import { SetModal } from '@src/domain/Ui/UiActions';
import { ModalType } from '@src/domain/Ui/UiConstants';
import Alert from '../legos/primitives/Alert';
import LinkButton from './LinkButton';

type OwnProps = {
  org?: OrganizationComplete;
}
const mapStateToProps = (state: IRootState) => ({
  trialActive: getTrialActive(state),
  trialStatus: getTrialStatus(state),
  hasPaidPro: getHasPaidPro(state),
  organizations: getOrganizationList(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  openCreateTrialOrgModal: () => dispatch(SetModal({ type: ModalType.CreateTrialOrg })),
});

const TrialStatusMessage: React.FC<TrialStatusMessageProps> = ({
  org,
  trialStatus,
  trialActive,
  hasPaidPro,
  organizations,
  openCreateTrialOrgModal,
}) => {
  if (!trialStatus || !trialActive || hasPaidPro) {
    return null;
  }

  let msg = 'Your free trial is active until';

  if (org && hasTrialOrgStarted(org)) {
    msg = `Trial period for "${org.name}" is active until`;
    trialStatus = org.subscriptions.suite.currentTermEnd;
  }

  const message = organizations.length > 0
    ? (
      <div>
        {msg} &nbsp;
        <span data-testid='trialEndDate'>
          {localizeDate(trialStatus)}
        </span>
      </div>
    )
    : (
      <div>
        Your free trial is active until {localizeDate(trialStatus)}.&nbsp;
        <LinkButton onClick={() => openCreateTrialOrgModal()}>
          Start a multi-user trial and add your teammates
        </LinkButton>
        &nbsp;to extend your trial an additional 30 days.
      </div>
    );

  return <Alert message={message} type='info' />;
};

type TrialStatusMessageProps = OwnProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(TrialStatusMessage);
